"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function LabelGroupPart({ identifier, title, selectedPartId, onSelectLabelPartID, }) {
    const isSelected = identifier === selectedPartId;
    const onItemClick = (0, react_1.useCallback)(() => {
        onSelectLabelPartID(identifier);
    }, [identifier, onSelectLabelPartID]);
    return ((0, jsx_runtime_1.jsx)(Container, { isSelected: isSelected, onClick: onItemClick, "data-e2e": 'LabelGroupPart_Container', children: (0, jsx_runtime_1.jsx)(PrimaryName, { isSelected: isSelected, "data-e2e": 'LabelGroupPart_PrimaryName', children: title }) }));
}
exports.default = (0, react_1.memo)(LabelGroupPart);
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: fit-content;
  min-height: 44px;
  font-size: 16px;
  padding: 8px;
  cursor: pointer;

  background: ${({ theme }) => theme.grasshopper.spotsPanel.selectedBackground};
  color: ${({ theme, isSelected }) => isSelected
    ? theme.grasshopper.text.white
    : theme.grasshopper.text.whiteSecondary};

  &:hover {
    color: ${({ theme }) => theme.grasshopper.text.white};
  }
`;
const PrimaryName = styled_components_1.default.div `
  line-height: 24px;
  font-size: 16px;
  padding: 0 8px 0 56px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
`;
